import React from "react";

const App = ({ children = {} }) => (
	<React.Fragment>
				{children}	
	</React.Fragment>
);

export default App;
